// Copyright (c) 2026 Isolated Networks. All rights reserved.
// Proprietary and confidential. Unauthorized copying, distribution, or use
// of this file, via any medium, is strictly prohibited.
// SPDX-License-Identifier: LicenseRef-Proprietary

/**
 * Isolated Networks design tokens — runtime source of truth.
 * Source: Logo Application Guide (2023-09-28). See frontend/DESIGN.md.
 *
 * Prefer these (or MUI theme mapped from them) over inventing hex in components.
 */

export const designTokens = {
  brand: {
    indigo: '#211E71',
    cyan: '#0098DF',
    charcoal: '#58585B',
    slate: '#6D6E71',
    softBlue: '#A8CBEB',
    silver: '#BCBEC0',
  },
  brandRgb: {
    indigo: '33, 30, 113',
    cyan: '0, 152, 223',
    charcoal: '88, 88, 91',
    slate: '109, 110, 113',
    softBlue: '168, 203, 235',
    silver: '188, 190, 192',
  },
  /** Indigo-cast dark surfaces — never pure #000 */
  surface: {
    pageDeep: '#0A0A18',
    pageMid: '#12122E',
    card: '#0E0E24',
    elevated: '#1A1D36',
    deepest: '#070712',
    /** Legacy aliases used by ThemeContext */
    ink: '#0B0C18',
    paper: '#121428',
  },
  status: {
    online: '#34C77B',
    degraded: '#E0A33A',
    offline: '#D8615F',
    neutral: '#6D6E71',
  },
  /** CircuitCheck partner (light-mode secondary only) */
  partner: {
    green: '#6ab04c',
    greenDark: '#559a3b',
    greenLight: '#82c264',
  },
  fonts: {
    sans: ['"Maven Pro"', 'Arial', 'Helvetica', 'sans-serif'].join(','),
    mono: ['"JetBrains Mono"', 'Consolas', 'monospace'].join(','),
  },
  weights: {
    body: 400,
    subhead: 700,
    emphasis: 800,
  },
  logo: {
    reverse: '/brand/Isolated-Networks-Reverse-Color.png',
    full: '/brand/Isolated-Networks-Full-Color.png',
    oneColor: '/brand/Isolated-Networks-1-Color.png',
    mark: '/kin-logo.svg',
    kin: '/brand/KIN.png',
  },
};

/** @deprecated Prefer designTokens — kept for existing imports */
export const brand = {
  navy: designTokens.brand.indigo,
  cyan: designTokens.brand.cyan,
  gray: designTokens.brand.charcoal,
  grayMid: designTokens.brand.slate,
  sky: designTokens.brand.softBlue,
  grayLight: designTokens.brand.silver,
  ink: designTokens.surface.ink,
  surface: designTokens.surface.paper,
  elevated: designTokens.surface.elevated,
  partnerGreen: designTokens.partner.green,
  partnerGreenDark: designTokens.partner.greenDark,
  partnerGreenLight: designTokens.partner.greenLight,
  success: designTokens.status.online,
  warning: designTokens.status.degraded,
  error: designTokens.status.offline,
  white: '#FFFFFF',
  offWhite: '#F0F2F5',
};

export const brandRgb = {
  navy: designTokens.brandRgb.indigo,
  cyan: designTokens.brandRgb.cyan,
  gray: designTokens.brandRgb.charcoal,
  grayMid: designTokens.brandRgb.slate,
  sky: designTokens.brandRgb.softBlue,
  grayLight: designTokens.brandRgb.silver,
};

export const brandFontFamily = designTokens.fonts.sans;

export default designTokens;
